/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_RedInputs */

const en_booking_color_red = /** @type {(inputs: Booking_Color_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red`)
};

const pl_booking_color_red = /** @type {(inputs: Booking_Color_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czerwony`)
};

/**
* | output |
* | --- |
* | "Red" |
*
* @param {Booking_Color_RedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_red = /** @type {((inputs?: Booking_Color_RedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_RedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_red(inputs)
	return en_booking_color_red(inputs)
});